import styled from 'styled-components';

export const Hstack = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
